import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Card} from 'semantic-ui-react';

interface HtmlViewerProps {
  headerElements?: JSX.Element[];
  notFoundElements?: React.ReactNode;
  htmlNotFound?: boolean;
  height?: number;
  src?: string;
  trackSuccess?: () => void;
  trackError?: () => void;
}

// a single image card
const HtmlViewer = (props: HtmlViewerProps) => {
  const {
    headerElements,
    notFoundElements,
    height,
    htmlNotFound,
    src,
    trackSuccess,
    trackError,
  } = props;

  return (
    <div
      data-test="html-viewer"
      style={{padding: '10px', height: '100%', width: '100%'}}>
      <Card className="html-card" style={{width: '100%'}}>
        {headerElements}
        {/* eslint-disable-next-line no-extra-boolean-cast */}
        {!!htmlNotFound ? (
          notFoundElements
        ) : (
          <iframe
            title="Html card"
            sandbox="allow-scripts"
            style={{border: 'none', height: (height ? height : 300) - 50}}
            src={src}
            onLoad={trackSuccess}
            onError={trackError}
          />
        )}
      </Card>
    </div>
  );
};

export default HtmlViewer;
